import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/search-for-campaigns.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-align-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "BROWSE CAMPAIGNS"),
  /*#__PURE__*/_createElementVNode("div", { class: "p-mt-2" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text p-mt-6" }, "Check out all running campaings")
], -1)
const _hoisted_3 = { class: "p-d-flex p-justify-center padding-bot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.show,
      class: "welcome-modal p-col-12 p-md-6 p-xl-4 search-modal",
      dismissableMask: true,
      closable: true,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:show', false)))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            label: "Continue",
            class: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}